import React, { FC, ReactElement } from 'react';
import { Stack, Typography, Paper, SxProps, Theme } from '@mui/material';

export interface InfoDisplayProps {
  icon: ReactElement;
  title: string;
  subtitle: string;
  onClick?: () => void;
  highlightOnHover?: boolean;
}

export const InfoDisplay: FC<InfoDisplayProps> = ({
  icon,
  title,
  subtitle,
  onClick,
  highlightOnHover = false,
}: InfoDisplayProps) => {
  const isClickable = !!onClick;

  const paperSx: SxProps<Theme> = {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'background.default',
    borderStyle: 'dashed',
    ...(isClickable && {
      cursor: 'pointer',
      transition: 'background-color 0.2s',
    }),
    ...(isClickable &&
      highlightOnHover && {
        '&:hover': {
          backgroundColor: 'action.hover',
        },
      }),
  };

  return (
    <Paper elevation={0} variant="outlined" sx={paperSx} onClick={onClick}>
      <Stack spacing={2} alignItems="center" color="text.secondary">
        {React.cloneElement(icon, { sx: { fontSize: 64, opacity: 0.5 } })}
        <Typography variant="h6" align="center">
          {title}
        </Typography>
        <Typography variant="body2" align="center" sx={{ maxWidth: 300 }}>
          {subtitle}
        </Typography>
      </Stack>
    </Paper>
  );
};
